import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * When a user first visits the site call geoip detect endpoint
 * to determine if the language dialog should be shown
 */
import renderToString from "preact-render-to-string";
import Cookies from "js-cookie";
const DEFAULT_LOCALE = "en-150";
class LanguageDialog {
    static initEvents() {
        document.addEventListener("DOMContentLoaded", LanguageDialog.detectLanguage);
    }
    static detectLanguage() {
        var _a;
        if (LanguageDialog.getDismissedCookie() === "true") {
            return;
        }
        // Get language urls from language switcher element
        const switcher = document.getElementById("language-switcher");
        if (switcher === null) {
            throw new Error("Language switcher element not found");
        }
        // Can be used to determine the suggested url
        const languageUrls = JSON.parse((_a = switcher.dataset.languageUrls) !== null && _a !== void 0 ? _a : "{}");
        fetch("/wp-json/class/v1/geoipdetect/", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        }).then((data) => {
            var _a, _b, _c, _d;
            const currentLanguage = (_a = document.getElementsByTagName("html")[0].getAttribute("lang")) !== null && _a !== void 0 ? _a : DEFAULT_LOCALE;
            const continent = data.result.continent.code;
            const country = data.result.country.iso_code;
            const isEU = continent === "EU";
            const isUS = country === "US";
            const isJP = false; //country === "JP";
            /** Check if the current language is the same as the detected language */
            if (isEU && currentLanguage === "en-150") {
                // User is in Europe and language is already set to en-150
                // Do nothing
                return;
            }
            if (isUS && currentLanguage === "en-US") {
                // User is in the US and language is already set to en-US
                // Do nothing
                return;
            }
            if (isJP && currentLanguage === "ja") {
                // User is in Japan and language is already set to ja
                // Do nothing
                return;
            }
            if (!isEU && !isUS && !isJP) {
                // User is not in Europe, US, or Japan
                // Do nothing
                return;
            }
            const dialogHTML = LanguageDialog.renderLanguageDialog({
                url: languageUrls[isEU ? "en-150" : isUS ? "en-US" : "ja"],
                country_name: (data.result.country.names.en === "United Kingdom" ? "the " : "") + data.result.country.names.en,
                country_iso_code: isUS || isJP ? country : continent,
            });
            const footerElement = (_b = document.getElementById("footer")) !== null && _b !== void 0 ? _b : document.createElement("div");
            footerElement.insertAdjacentHTML("afterend", dialogHTML);
            // Add event listener to dialog button to dismiss the language dialog
            const dialogElement = (_c = document.getElementById("language-dialog")) !== null && _c !== void 0 ? _c : document.createElement("div");
            const dismissBtn = (_d = dialogElement.querySelector("[data-action='close']")) !== null && _d !== void 0 ? _d : document.createElement("button");
            dismissBtn.addEventListener("click", (event) => {
                event.preventDefault();
                LanguageDialog.setDismissedCookie();
                dialogElement.remove();
            });
            // alert(JSON.stringify(data));
        }).catch((error) => {
            console.error("Error:", error);
        });
    }
    static getDismissedCookie() {
        return Cookies.get("language_dialog_dismissed");
    }
    static setDismissedCookie(value = "true") {
        Cookies.set("language_dialog_dismissed", value, { expires: 7 });
    }
    // Generate the language dialog markup
    static renderLanguageDialog(props) {
        const { country_name, country_iso_code, url } = props;
        const TITLE_TEXT = `Looks like your visiting from ${country_name}`;
        const COPY_TEXT = (_jsxs(_Fragment, { children: [_jsx("p", { children: `Would you like to visit the ${country_iso_code} site.` }), _jsx("p", { children: "If you choose to \"Stay Here\" you can change the site by using the language switcher in the menu." })] }));
        const LEAVE_BTN_TEXT = `${country_iso_code} Website`;
        const DISMISS_BTN_TEXT = "Stay Here";
        const modal = (_jsx("dialog", { id: "language-dialog", className: "modal modal-language-dialog", open: true, children: _jsx("div", { className: "modal__dialog", children: _jsxs("div", { className: "modal__content", children: [_jsxs("div", { className: "modal__header", children: [_jsx("h2", { className: "h4 modal__title", children: TITLE_TEXT }), _jsx("div", { className: "modal__copy", children: COPY_TEXT })] }), _jsxs("ul", { className: "list--inline", children: [_jsx("li", { children: _jsx("a", { href: url, className: "btn btn-secondary", children: LEAVE_BTN_TEXT }) }), _jsx("li", { children: _jsx("button", { type: "button", className: "btn btn-primary", "data-action": "close", children: DISMISS_BTN_TEXT }) })] })] }) }) }));
        return renderToString(modal);
    }
}
LanguageDialog.initEvents();
export default LanguageDialog;
